<template>
    <section class="help">
        <div class="bg-gradient">
            <div class="container ">
                <div class="row">
                    <div class="col-md-12 help-title">
                        <h2>Помогают и нуждаются прямо сейчас </h2>
                    </div>
                </div>
            </div>
        </div>

        <div id="transaction-wrapper" class="container">
            <div class="row">
                <div class="col-md-12 col-lg-6">
                    <h5>Отчет о поступлениях</h5>
                    <div class="receipts">
                        <div class="receipt d-flex" v-for="(transaction, index) in transaction_list" :key="index">
                            <div class="receipt-info">
                                <p class="receipt-name">{{transaction.user.name}}</p>
                                <h6>{{transaction.target.name}}</h6>
                                <p class="receipt-date">{{transaction.created_at}}</p>
                            </div>
                            <div class="receipt-price">
                                <p>{{transaction.credit}} BYN</p>
                            </div>
                        </div>
                    </div>

                    <div class="summary">
                        <h6>{{total_donation}} BYN</h6>
                        <p>всего собрано</p>
                    </div>
                </div>
                <div class="col-md-12 col-lg-6">
                    <div class="animals-now">
                        <h6>{{quantity}}</h6>
                        <p>Они ждут вашей помощи
                            <br/> Помочь может каждый</p>
                    </div>
                    <div class="map-bg">
                        <div class="animal-item" v-for="pet in petslist.slice(0, 8)">
                            <div class="image" v-if="pet.avatar">
                                <img v-if="media > 768" :src="'/storage' + pet.avatar.path.replace('original', 'avatar')" :alt="pet.name">
                                <img v-else :src="'/storage' + pet.avatar.path.replace('original', 'preview_l')" :alt="pet.name">
                                <!-- TODO  ссылка на данат животному   -->
                                <div class="image-descr">
                                    <a class="image-btn" :href="'pets/' + pet.id">Помочь!</a>
                                </div>
                            </div>
                            <div class="descr">
                                <h6>
                                    <span class="title">{{pet.name}}</span>
                                    <!-- TODO  прокинуть иконку и цвет категории  -->
                                    <span class="icon" :style="{background: pet.filters[0] ? pet.filters[0].color : '#91DA66'}">
                                        <img v-if="pet.filters" :src="'/assets/images/' + pet.filters[0].icon" alt="">
                                        <img v-else src="/assets/images/sos.svg" alt="">
                                    </span>
                                </h6>
                                <!-- TODO прокинуть причину помощи  -->
                                <p>{{ pet.filters[0].name }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <a href="/catalog/pets" class="btn">Смотреть все ситуации</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props:['petslist', 'quantity', 'transactions', 'total_donation'],
    data() {
        return {
            'transaction_list' : this.transactions,
            'transactionKey' : 0,
            appRoutes: null,
            media: null
        }
    },
    created() {
        this.myEventHandler()
        window.addEventListener("resize", this.myEventHandler);
    },
    destroyed(){
        window.removeEventListener("resize", this.myEventHandler);
    },
    mounted() {
        if (this.transactions.length > 5) {
            var lastTransaction = this.transactions.splice(this.transactions.length-1, 1);
            this.transactions.unshift(lastTransaction[0]);
            this.transaction_list = this.transactions;
            this.transactionKey += 1;
        }
        // console.log(this.petslist)
    },
    methods:{
        myEventHandler(e){
            this.media = window.innerWidth
        },
    }
}
</script>

<style lang="scss">
.help{
    background: #ffffff;
    margin-bottom: 50px !important;
    &-title{
        display: flex;
        align-items: center;
        height: 120px;
        font-size: 40px;
        font-family: 'Comfortaa', cursive;
        color: #ffffff;
    }
    h5{
        color: #555555;
        font-weight: normal;
        font-size: 24px;
        font-family: 'Comfortaa', cursive;
        margin: 24px 0;
    }
    p, h6{
        margin-bottom: 0;
    }
    #transaction-wrapper{
        min-height: 700px;
    }

    .receipt-info{
        min-width: 150px;
        padding-right: 10px;
        .receipt-name{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        h6{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

    }

    .receipt-price{
        white-space: nowrap;
    }

    .receipts{
        position: relative;
        height: 500px;
        .receipt{
            opacity: 0;
            position: absolute;
            animation: animateme infinite;
            animation-duration: 12s;
            font-family: 'Comfortaa', cursive;
            justify-content: space-between;
            align-items: center;
            background: #EAF1FC;
            border: 1px solid #DDE6F5;
            border-radius: 5px;
            padding: 16px;
            margin-bottom: 6px;
            width: 100%;
            .receipt-name{
                color: #555555;
                font-size: 12px;
            }
            h6{
                color: #2E76E4;
                font-size: 18px;
                margin: 5px 0;
            }
            .receipt-date{
                color: #555555;
                font-size: 9px;
            }
            .receipt-price{
                p{
                    color: #2E76E4;
                    font-size: 28px;
                }
            }
        }
        /*
        .receipt:first-child{
            animation: show 5s;
        }
        .receipt:last-child{
            animation: hide 5s;
        }
        */
        .receipt:nth-child(1){
            animation-delay: -27s;
        }
        .receipt:nth-child(2){
            animation-delay: -25s;
        }
        .receipt:nth-child(3){
            animation-delay: -23s;
        }
        .receipt:nth-child(4){
            animation-delay: -21s;
        }
        .receipt:nth-child(5){
            animation-delay: -19s;
        }
        .receipt:nth-child(6){
            animation-delay: -17s;
        }
        .receipt:nth-child(7){
            animation-delay: -15s;
        }
        .receipt:nth-child(8){
            animation-delay: -13s;
        }
        .receipt:nth-child(9){
            animation-delay: -11s;
        }
        .receipt:nth-child(10){
            animation-delay: -9s;
        }
        .receipt:nth-child(11) {
            animation-delay: -7s;
        }
        .receipt:nth-child(12) {
            animation-delay: -5s;
        }
        .receipt:nth-child(13) {
            animation-delay: -3s;
        }
        .receipt:nth-child(14) {
            animation-delay: -1s;
        }
        .receipt:nth-child(15) {
            animation-delay: 1s;
        }
    }
    .summary{
        color: #2E76E4;
        font-family: 'Roboto', sans-serif;
        font-weight: 900;
        text-align: right;
        h6{
            font-size: 64px;
        }
        p{
            font-size: 24px;
        }
    }
    .map-bg{
        background-image: url('/assets/images/main_page/Map.png');
        background-size: cover;
        background-position: bottom right;
        background-repeat: no-repeat;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 90px 40px;
        min-height: 470px;
        .animal-item{
            margin: 0 5px 10px;
            width: calc(25% - 10px);
            margin-bottom: 15px;
            .image{
                position: relative;
                width: 100%;
                height: 100px;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .image-descr{
                    opacity: 0;
                    transition: all 0.7s;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: linear-gradient(90.72deg, rgba(46, 118, 228, 0.7) 0.56%, rgba(108, 77, 187, 0.7) 99.34%);
                    cursor: pointer;
                    p{
                        border: 2px solid #ffffff;
                        border-radius: 20px;
                        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
                        color: #ffffff;
                        padding: 5px;
                        font-size: 10px;
                    }
                }
                .image-btn{
                    background: transparent;
                    border: 1px solid #fff;
                    padding: 10px;
                    font-size: 10px;
                    border-radius: 30px;
                    color: #fff;
                    transition: opacity .2s ease;
                    &:hover{
                        color: #fff;
                        opacity: .8;
                    }
                }
                &:hover .image-descr{
                    opacity: 1;
                }
            }
            .descr{
                background: #ffffff;
                box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
                padding: 6px;
                h6{
                    font-size: 10px;
                    display: flex;
                    justify-content: space-between;
                    .title{
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                        font-weight: 700;
                    }
                    .icon{
                        border-radius: 100%;
                        width: 15px !important;
                        min-width: 15px;
                        height: 15px !important;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img{
                            width: 9px !important;
                        }
                    }
                    .bg-green{
                        background: #91DA66;
                    }
                    .bg-pink{
                        background: #EE7372;
                        img{
                            margin-left: -1px;
                        }
                    }
                }
                p{
                    font-size: 7px;
                    color: #929292;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                }
            }
        }
    }
    .animals-now{
        display: flex;
        justify-content: flex-end;
        color: #6C4DBB;
        font-family: 'Roboto', sans-serif;
        font-weight: 900;
        margin-top: 80px;
        h6{
            font-size: 64px;
        }
        p{
            margin-left: 10px;
            font-size: 24px;
        }
    }
}
@media only screen and (max-width: 1200px){
    .help .map-bg{
        background-size: contain;
        background-position: center;
        padding: 90px 20px;
    }
}
@media only screen and (max-width: 992px) {
    .help .help-title {
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        justify-content: center;
    }
    .help h5{
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        justify-content: center;
    }
    .help .animals-now{
        justify-content: flex-start;
        margin-top: 30px;
    }
    .help .animals-now h6,
    .help .summary h6{
        font-size: 30px;
    }
    .help .animals-now p,
    .help .summary p{
        font-size: 18px;
    }
    .help .map-bg{
        padding: 40px 0;
    }
    .help .map-bg .animal-item .descr h6 .icon{
        width: 20px !important;
        height: 20px !important;
        min-width: 20px;
    }
    .help .map-bg .animal-item .descr h6 .icon img{
        width: 13px !important;
    }
    .help .map-bg .animal-item .descr h6{
        font-size: 12px;
    }
    .help .map-bg .animal-item .descr p{
        font-size: 10px;
    }
}
@media only screen and (max-width: 768px){
    .help .map-bg{
        background-image: none;
    }
    .help .map-bg .animal-item{
        width: calc(50% - 10px);
    }
    .help .map-bg .animal-item .image{
        height: 200px;
    }
    .help .map-bg .animal-item .image .image-descr{
        height: 100%;
    }
}
@media only screen and (max-width: 480px){
    .help .map-bg .animal-item .image{
        height: 150px;
    }
    .help .receipts .receipt .receipt-price p{
        font-size: 18px;
    }
    .help .receipts .receipt h6{
        font-size: 16px;
    }
}
.slideInDown {
    animation-name: slideInDown;
    animation-duration: 1s;
    animation-fill-mode: both;
}
@keyframes animateme {
    0% {
        opacity: 0;
    }
    7.142857142857143% {
        opacity: 1;
    }
    14.285714285714286% {
        opacity: 1;
    }
    21.428571428571429% {
        opacity: 1;
    }
    28.571428571428572% {
        opacity: 1;
    }
    35.714285714285715% {
        top: 0;
        opacity: 1;
    }
    42.857142857142858% {
        top: 0;
        opacity: 1;
    }
    50% {
        top: 100px;
        opacity: 1;
    }
    57.142857142857143% {
        top: 100px;
        opacity: 1;
    }
    64.285714285714286% {
        top: 200px;
        opacity: 1;
    }
    71.428571428571429% {
        top: 200px;
        opacity: 1;
    }
    78.571428571428572% {
        top: 300px;
        opacity: 1;
    }
    85.714285714285715% {
        top: 300px;
        opacity: 1;
    }
    87% {
        top: 300px;
    }
    100% {
        top: 400px;
    }
}
</style>
